import React from 'react';
import { arrayOf, func, number, oneOfType, shape, string } from 'prop-types';
import { components } from 'react-select';
import setClass from '../../common/set-class';
import Flex from '../layout';
import Checkbox from '../checkbox';
const Option = (props) => {
    const { selectOption, data, selectProps: { value: values }, } = props;
    const isSelected = !!values.find(({ value }) => value === data.value);
    return (React.createElement(Flex, { align: "center", className: setClass([
            'b-async-select-multi__option-container',
            isSelected ? 'b-async-select-multi__option-container--selected' : '',
        ]) },
        React.createElement(Checkbox, { checked: isSelected, onChange: () => selectOption(data) }),
        React.createElement(components.Option, { ...props })));
};
Option.propTypes = {
    data: shape({ label: string, value: oneOfType([string, number]) }),
    selectOption: func.isRequired,
    selectProps: shape({
        value: arrayOf(shape({ label: string, value: oneOfType([string, number]) })),
    }),
};
Option.defaultProps = {
    data: {},
    selectProps: { value: [] },
};
export default Option;
